<template>
  <div class="yk-home-tf--wrapper">
    <el-form ref="formOption"
             label-width="100px"
             label-position="left">
      <el-form-item label="题目：">
        <div v-if="IsTitle">
          <Editor placeholder="请输入内容" />
        </div>
        <div v-else
             class="yk-claer-style-margin">
          <span v-html="data.Content"
                class="yk-multiselect-question  yk-span-wrapper"></span>
        </div>
      </el-form-item>
      <el-form-item label="题目附件：" v-if="filesList.length > 0">
        <div v-if="IsTitle">
          <QuestionFile ref="fileList"
                        :url="urlAliyunOSS"
                        :fileIds.sync="fileIds"
                        :filesList="filesList"
                        :files.sync="fileList"
                        :IsUpload="false"/>
        </div>
        <div v-else>
          <QuestionFile ref="fileList"
                        :url="urlAliyunOSS"
                        :fileIds.sync="fileIds"
                        :filesList="filesList"
                        :files.sync="fileList"
                        :IsUpload="false"/>
        </div>
      </el-form-item>
      <div>
        <div v-if="IsSelects == 0">
          <el-form-item label="选项：">
            <el-radio-group v-model="formOption.choice">
              <el-radio label="对"></el-radio>
              <el-radio label="错"></el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div v-else-if="IsSelects> 0">
          <el-form-item label="选项：">
            <el-radio-group v-model="stuAnswer[0]"
                            @change="doCheckValue">
              <el-radio label=1>对</el-radio>
              <el-radio label=0>错</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </div>
      <el-form-item label="答案："
                    v-if="IsAnswers && isBook">
        <span v-if="data.Answers == 1">对</span>
        <span v-else>错</span>
      </el-form-item>
      <el-form-item label="解析："
                    v-if="showThisAnswer && isBook">
        <!-- <Editor v-if="IsAnalysis > 0" placeholder="请输入内容" /> -->
        <div>
          <span v-html="data.Analysis">{{data.Analysis}}</span>
        </div>
      </el-form-item>
      <el-form-item label="解析附件："
                    v-if="showThisAnswer && analysisFilesList.length > 0 && isBook">
        <QuestionFile ref="analysisFileList"
                      :url="urlAliyunOSS"
                      :fileIds.sync="analysisFileIds"
                      :filesList="analysisFilesList"
                      :files.sync="analysisFileList"
                      :IsUpload="false"/>
      </el-form-item>
    </el-form>
    <div class="yk-mm-up-down-wrapper"
         @click="upDown"
         v-if="anaShow && isBook">
      <i class="el-icon-arrow-up"></i>
      <span>收起解析</span>
    </div>
    <div class="yk-mm-up-down-wrapper"
         @click="upDown"
         v-if="!anaShow && isBook">
      <i class="el-icon-arrow-down"></i>
      <span>查看解析</span>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue';
import QuestionFile from 'components/AliyunOSS/QuestionFileNew.vue';
export default {
  name: 'true-false',
  components: {
    QuestionFile
  },
  props: {
    isBook:{
      type: Boolean,
      default: true
    },
    IsTitle: {
      type: Boolean,
      default: true
    },
    IsSelects: {
      type: Number,
      default: 0
    },
    IsAnswers: {
      type: Boolean,
      default: 0
    },
    IsAnalysis: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default: function() {
        return {};
      }
    },
    title: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  watch: {},
  data() {
    return {
      urlAliyunOSS: "/api/design/osssign/getsign",
      // 题干附件
      fileList: [],
      fileIds: [], // 附件Id
      filesList: [],
      // 解析附件
      analysisFileList: [],
      analysisFileIds: [],
      analysisFilesList: [],
      showThisAnswer: true,
      anaShow: true,
      content: '请输入内容',
      formOption: {
        choice: null
      },
      stuAnswer: []
    };
  },
  methods: {
    // 做作业是选择答案
    doCheckValue: function() {
      this.$emit('getAnswer', {
        Id: this.data.Id,
        Answers: this.stuAnswer
      });
    },
    upDown() {
      this.showThisAnswer = !this.showThisAnswer;
      this.anaShow = !this.anaShow;
    }
  },
  created() {
    if (this.data.Answers) {
      this.stuAnswer = this.data.Answers;
    }
    // 题目附件
    this.filesList = this.data.stemFiles;
    this.analysisFilesList = this.data.analysisFiles;
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '~theme/page/components/variables.scss';
.yk-home-tf--wrapper {
  position: relative;
  padding: 0 20px;
  .yk-multiselect-question {
    p {
      margin: 0;
      padding: 0;
    }
  }
  .el-form-item__label,
  .el-form-item__content {
    color: black;
    font-size: 16px;
  }
  .yk-mm-up-down-wrapper {
    position: absolute;
    width: 240px;
    height: 30px;
    background: #f5f5f5;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
    bottom: -50px;
    left: 50%;
    margin-left: -120px;
    border-radius: 0 0 30px 30px;
    text-align: center;
    line-height: 30px;
  }
}
</style>
